import React, { useState, useEffect } from 'react';
import CenterPanel from './centerPanel';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { useFormik } from 'formik';
import libphonenumber from 'google-libphonenumber';
import { phoneTypesEnum } from '../../../../businessLogic/validation.js';
import { useStringValidation } from 'businessLogic/helperHooks';

// There are shared states and function between center panel and right panel
function CenterAndRightPanelComponent(props) {
  const [additionalTextMessage, setAdditionalTextMessage] = useState(props.waURLTextData.additionalMessage);
  const [characterLeftForText, setCharacterLeftForText] = useState(100);

  const [showMobileErrorDetail, setShowMobileErrorDetail] = useState(false);
  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
  const countryCode = window.APP.CONFIGURATION.VALIDATION.CountryCode || 'GB';

  const textMessageCharacterLimit = 100;

  const formik = useFormik({
    initialValues: {
      mobile: '',
    },
    validate: (values, prop) => {
      const errors = {};
      if (!values.mobile) {
        errors.mobile = APP.LANGUAGE.Errors.NoValidPhoneNumber;
      } else if (values.mobile.indexOf(',') > -1) {
        errors.mobile = APP.LANGUAGE.ShareURL.OneMobileAllowError;
      } else {
        try {
          let number = phoneUtil.parseAndKeepRawInput(values.mobile, countryCode);
          if (phoneUtil.isValidNumber(number)) {
            let numberType = phoneUtil.getNumberType(number);
            if (
              !(
                numberType == phoneTypesEnum.MOBILE ||
                numberType == phoneTypesEnum.FIXED_LINE_OR_MOBILE ||
                numberType == phoneTypesEnum.PERSONAL_NUMBER
              )
            ) {
              errors.mobile = APP.LANGUAGE.Errors.NoValidPhoneNumber;
            }
          } else {
            errors.mobile = APP.LANGUAGE.Errors.NoValidPhoneNumber;
          }
        } catch (err) {
          errors.mobile = APP.LANGUAGE.Errors.NoValidPhoneNumber;
        }
      }
      return errors;
    },
  });

  const textMessageValidState = useStringValidation({
    checkCharacterLimt: true,
    characterLimt: textMessageCharacterLimit,
    checkASCII: true,
    str: additionalTextMessage,
  });

  useEffect(() => {
    if (!formik.errors.mobile) {
      setShowMobileErrorDetail(false);
    }
  }, [formik.errors.mobile]);

  return (
    <React.Fragment>
      <div className="content body-content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel" style={{ minHeight: '400px' }}>
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanelTop
                  formik={formik}
                  waitingArea={props.waitingArea}
                  allowEdit={props.waURLTextData.isEditAllowed}
                  additionalTextMessage={additionalTextMessage}
                  textMessageValidState={textMessageValidState}
                />
              </div>
              <RightPanelBottom />
            </div>
            <CenterPanel
              waURLTextData={props.waURLTextData}
              waitingArea={props.waitingArea}
              formik={formik}
              showMobileErrorDetail={showMobileErrorDetail}
              setShowMobileErrorDetail={setShowMobileErrorDetail}
              additionalTextMessage={additionalTextMessage}
              setAdditionalTextMessage={setAdditionalTextMessage}
              textMessageCharacterLimit={textMessageCharacterLimit}
              textMessageValidState={textMessageValidState}
              isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
            />
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <div className="mrtm">
                <RightPanelBottom />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-rail-with-left-and-right-content mrtnull">
        <RightPanelTop
          formik={formik}
          waitingArea={props.waitingArea}
          allowEdit={props.waURLTextData.isEditAllowed}
          additionalTextMessage={additionalTextMessage}
          textMessageValidState={textMessageValidState}
        />
      </div>
    </React.Fragment>
  );
}

export default function ShareByTextWaitingArea(props) {
  return (
    <Modal show={true} hideWhenClickAway={false} className="waiting-area-share-by-text fixed-header-footer-mobile">
      <PopupHeader
        title={APP.LANGUAGE.ShareURL.Title}
        subtitle={props.waitingArea.name}
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpSendWAURL}
      />
      <CenterAndRightPanelComponent
        waitingArea={props.waitingArea}
        waURLTextData={props.waURLTextData}
        isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
      />
    </Modal>
  );
}
